// Identifie quel bouton de la nav doit être surligné
export type BottomNavButton =
  | 'accueil'
  | 'catalogue'
  | 'mes-produits'
  | 'conversations'
  | 'profil';

export function isBottomNavActive(
  pathname: string,
  button: BottomNavButton,
): boolean {
  switch (button) {
    case 'accueil':
      return pathname.includes('/accueil');

    case 'catalogue':
      return (
        pathname.includes('/catalogue') ||
        pathname.includes('/produit/') ||
        pathname.includes('/recherche')
      );

    case 'mes-produits':
      return pathname.includes('/mes-produits');

    case 'conversations':
      return pathname.includes('/conversations');

    case 'profil':
      return (
        pathname.includes('/menuClient') ||
        pathname.includes('/profil') ||
        pathname.includes('/commandes') ||
        pathname.includes('/factures') ||
        pathname.includes('/livraisons') ||
        pathname.includes('/contacts') ||
        pathname.includes('/preferences') ||
        pathname.includes('/mentions_legales')
      );

    default:
      return false;
  }
}
